export const Status = {
    UNCHEKED: 0,
    SUCCESS: 1,
    ERROR: 2
};

export const withdrawalStatus = {
    ALLOW_WITHDRAWAL: 1
};
